import { ReactNode } from 'react';

import { useAuthDataSubscriber } from './hooks/useAuthDataSubscriber';

export interface IAuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: IAuthProviderProps) => {
  useAuthDataSubscriber();

  return children;
};
